import client from './client';

export interface DeviceContact {
  id: number;
  specification_id: number;
  contact_number: string;
  contact_position: 'top' | 'bottom' | 'left' | 'right' | null;
  contact_label: string;
  color_code: string;
  properties: any;
  schema_type_ids?: number[] | string | null;
  schema_ids?: number[] | string | null; // Array of specific schema IDs
}

export interface TerminalInternalConnection {
  id: number;
  specification_id: number;
  contact_from_id: number;
  contact_to_id: number;
  connection_type: string;
  level_number: number | null;
  description: string | null;
  from_contact: string;
  to_contact: string;
  from_contact_number?: string;
  to_contact_number?: string;
  created_at?: string;
  updated_at?: string;
}

export const getDeviceContacts = async (specificationId: number): Promise<DeviceContact[]> => {
  const response = await client.get(`/api/device_contacts?specification_id=${specificationId}`);
  return response.data;
};

export const getTerminalInternalConnections = async (specificationId: number): Promise<TerminalInternalConnection[]> => {
  const response = await client.get(`/api/terminal_internal_connections/${specificationId}`);
  return response.data;
};

export const createDeviceContact = async (contactData: Partial<DeviceContact>): Promise<DeviceContact> => {
  const response = await client.post('/api/device_contacts', contactData);
  return response.data;
};

export const updateDeviceContact = async (id: number, contactData: Partial<DeviceContact>): Promise<DeviceContact> => {
  const response = await client.put(`/api/device_contacts/${id}`, contactData);
  return response.data;
};

export const deleteDeviceContact = async (id: number): Promise<void> => {
  await client.delete(`/api/device_contacts/${id}`);
};

export const createTerminalInternalConnection = async (connectionData: {
  specification_id: number
  contact_from_id: number
  contact_to_id: number
  level_number?: number | null
  connection_type?: string
  description?: string | null
}): Promise<TerminalInternalConnection> => {
  const response = await client.post('/api/terminal_internal_connections', connectionData);
  return response.data;
}; 